import React from 'react';

import { cn } from '@/lib/utils';

const LINKS = [
    { label: 'Privacy Policy', href: '/privacy' },
    { label: 'Terms of Use', href: '/terms' },
] as const;

interface LegalLinksProps {
    /** Extra classes for placement (e.g. `self-center` in a flex footer). */
    className?: string;
}

/**
 * Persistent Privacy Policy / Terms of Use pair for the trade surface footers.
 *
 * Both open in a new tab rather than routing in place: these are full pages,
 * and navigating away from a screen with a live position on it to read a
 * policy is not a trade the user meant to make.
 *
 * Muted at the footer's own scale on purpose — legally present without
 * competing with the lime CTAs a few pixels above.
 */
const LegalLinks: React.FC<LegalLinksProps> = ({ className }) => (
    <nav
        aria-label="Legal"
        className={cn(
            'flex items-center justify-center gap-1.5 text-[10px] text-muted-foreground',
            className,
        )}
    >
        {LINKS.map(({ label, href }, index) => (
            <React.Fragment key={href}>
                {index > 0 && (
                    <span
                        aria-hidden="true"
                        className="text-muted-foreground/40"
                    >
                        ·
                    </span>
                )}
                <a
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition-colors hover:text-foreground"
                >
                    {label}
                </a>
            </React.Fragment>
        ))}
    </nav>
);

LegalLinks.displayName = 'LegalLinks';

export default LegalLinks;
